import { type IUsageFeeTier, type IPlanKey, IUsageFeeTierKey } from '../../types';

import { getRevenueRangeLabel, getUsageFeeDataByTierKey } from '../../helpers';
import { usePricingPlanPaidActive } from '../usePricingPlanPaidActive';
import { usePricingPlanData } from '../usePricingPlanData';
import { useUsageFeeTierStore } from '../../stores';
import { CONFIG_PRICING } from '../../configs';

interface IPricingUsageFeeTier {
  isHasUsageFee: boolean;
  usageFeeAmount: number;
  usageFeeTiersByPlan?: IUsageFeeTier[];
  usageFeeRangeTxt: string;
  usageFeeData?: IUsageFeeTier;
  maxUsageFeeTierAmount: number;
  minUsageFeeTierAmount: number;
  minUsageFeeTier?: IUsageFeeTier;
}

export const usePricingUsageFeeTier = (props?: { planKey?: IPlanKey }): IPricingUsageFeeTier => {
  const activeUsageFeeTierKey = useUsageFeeTierStore((state) => state.activeUsageFeeTierKey);
  const usageFeeTiers = useUsageFeeTierStore((state) => state.usageFeeTiers);

  const { planKey } = props ?? {};
  const { getPlanDataByPlanKey } = usePricingPlanData();
  const { paidPlan } = usePricingPlanPaidActive();

  const planByPlanKey = getPlanDataByPlanKey(planKey || CONFIG_PRICING.DEFAULT_USAGE_FEE_PLAN_KEY);
  const usageFeeTiersByPlan = usageFeeTiers?.filter((item) => item.planID === planByPlanKey?.id);
  const usageFeeData = getUsageFeeDataByTierKey(usageFeeTiersByPlan, activeUsageFeeTierKey);
  const usageFeeAmount = Number(usageFeeData?.amount ?? 0);
  const usageFeeRangeTxt = getRevenueRangeLabel(usageFeeData);
  const isHasUsageFee = !!usageFeeData;

  const maxUsageFeeTier = usageFeeTiers?.find(
    (item) => paidPlan?.id === item.planID && item.tierKey === IUsageFeeTierKey.MAX,
  );
  const minUsageFeeTier = usageFeeTiers?.find(
    (item) => paidPlan?.id === item.planID && item.tierKey === IUsageFeeTierKey.BASIC,
  );

  const minUsageFeeTierAmount = Number(minUsageFeeTier?.amount ?? 0);
  const maxUsageFeeTierAmount = Number(maxUsageFeeTier?.amount ?? 0);

  return {
    isHasUsageFee,
    usageFeeAmount,
    usageFeeData,
    usageFeeRangeTxt,
    usageFeeTiersByPlan,
    maxUsageFeeTierAmount,
    minUsageFeeTierAmount,
    minUsageFeeTier,
  };
};
